routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
    $stateProvider
        .state('dm', {
          url: '/inbox/:folder',
          template: require('./index.html'),
          controller: 'MessagesController',
          controllerAs: 'dm',
          data: {pageTitle: 'Inbox'},
          authRequired: true
        })
        .state('im', {
          url: '/inbox/:folder/:person',
          template: require('./index.html'),
          controller: 'MessagesController',
          data: {pageTitle: 'Messaging'},
          controllerAs: 'dm',
          authRequired: true
        });
}



// WEBPACK FOOTER //
// ./src/app/features/inbox/routes.js